import { createAction } from 'redux-actions';
import {
  UPDATE_CART,
  UPDATE_DELIVERY_ADDRESS,
  UPDATE_STORE_HOME_PAGE,
  UPDATE_ML_EXCLUSIVE_PAGE,
  UPDATE_LISTING,
  UPDATE_LISTING_FILTER_SUBCATEGORY,
  UPDATE_PDP,
  UPDATE_SORT_AND_FILTERS,
  CATEGORY_LISTING,
  CATEGORY_DESCRIPTION,
} from './type';

export const updateStoreHomepage = createAction(UPDATE_STORE_HOME_PAGE);
export const updateMlExclusivepage = createAction(UPDATE_ML_EXCLUSIVE_PAGE);
export const updateCart = createAction(UPDATE_CART);
export const updateListing = createAction(UPDATE_LISTING);
export const updateDeliveryAddress = createAction(UPDATE_DELIVERY_ADDRESS);
export const updateListingFilterSubcategory = createAction(
  UPDATE_LISTING_FILTER_SUBCATEGORY
);
export const updateSortAndFilters = createAction(UPDATE_SORT_AND_FILTERS);
export const updatePdp = createAction(UPDATE_PDP);

//category landing page actions
export const updateCategoryListing = createAction(CATEGORY_LISTING);
export const updateCategoryDescription = createAction(CATEGORY_DESCRIPTION);
